import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogoOuter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 300 300",
	style: { enableBackground: "new 0 0 300 300" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M151.6 15.6c-10.9-1.9-22.1-2.9-33.2-2.9-39.5 0-73.2 13.5-94.7 37.8C5.4 71.2-2.7 98.7.9 127.7c7 55.7 64.3 159.6 149.1 159.6 81.3 0 150-98.6 150-160.5 0-54.5-54-95-148.4-111.2zM194.3 245c-29.6 17.1-58.9 17.2-87.1.2-13.3-8-25.8-19.4-37.5-34.1-20.6-26-36.1-60.1-39.5-87-1.4-10.1-.6-20.1 2.2-29.9C35.1 85.3 39.7 77 45.9 70c15.8-17.9 41.6-27.8 72.5-27.8 9.4 0 19 .9 28.3 2.5 38.2 6.6 69.9 17.7 91.6 32.1 10.7 7.1 19 15 24.3 23.4 5.1 7.9 7.9 17.1 7.8 26.6 0 11.3-3.2 24.9-9.4 39.5-6.9 16-16.1 31-27.3 44.4-11.9 14.5-25.5 26.3-39.4 34.3z",
		fill: "currentColor"
	})
});
export { SvgLogoOuter as ReactComponent };
